import Image from 'next/image'

interface Props {
  logoUrl: string
  displayName?: string | null
  size?: number
}

export const VenueLogo = ({ logoUrl, displayName, size = 80 }: Props) => {
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <Image src={logoUrl} alt={displayName ?? 'Venue logo'} fill className="object-contain" priority />
    </div>
  )
}
